import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { get_post_Author } from "../../redux/actions";
import { Col, Image } from "react-bootstrap";

export default function UserInfoFromLogout() {
  const globalState = useSelector((state) => state);
  const dispatch = useDispatch();
  const params = useParams();

  useEffect(() => {
    dispatch(
      get_post_Author("get", `${process.env.REACT_APP_URL}/api/profiles/${params.id}`)
    );
  }, []);

  return (globalState.postAuthor ? 
    <div>
      <Col xs={6} md={4}>
        <Image className="user-info-profile-image" fluid src={globalState.postAuthor.profile.image} roundedCircle />
      </Col>
      <div>First Name: {globalState.postAuthor.profile.first_name}</div>
      <div>Last Name: {globalState.postAuthor.profile.last_name}</div>
      <div>Email: {globalState.postAuthor.profile.email}</div>
      <div>Bio: {globalState.postAuthor.profile.bio}</div>
    </div> : <div>Loading...</div>
  );
}
